<template>
    <StateAbstract class="state-loading">

        <!-- Progress Animation -->
        <div class="state-loading__progress">
            <v-progress-circular 
                indeterminate 
                class="state-loading__progress-circular" />
        </div>
        <span class="state-loading__message">synchronizing library</span>

    </StateAbstract>
</template>

<script>
import StateAbstract from '@/components/common/state/StateAbstract.vue'

export default {
    name: 'StateLoading',
    components: {
        StateAbstract
    }
}
</script>

<style scoped>
.state-loading__progress-circular {
    transform: scale(1.6);
    color: rgb(var(--v-theme-invert));
    text-shadow: 0px 0px 4px rgb(var(--v-theme-shadow1));
}

.state-loading__message {
    margin-top: 20px;
}
</style>